import * as RevenueActionTypes from '../constants/revenue/ActionTypes'

export const setAdsenseInfo = (adsenseInfo) => ({
    type: RevenueActionTypes.SET_ADSENSE_INFO,
    adsenseInfo,
});

export const setAdfitInfo = (adfitInfo) => ({
    type: RevenueActionTypes.SET_ADFIT_INFO,
    adfitInfo,
});